import React, { useState, useMemo } from 'react';
import Grid from '../components/Grid';
import Pagination from '../components/Pagination';
import jsPDF from 'jspdf';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const Reports = () => {
  const [selectedReport, setSelectedReport] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Sample data for reports (in a real app, this would come from API calls)
  const vendorsData = [
    { id: "1", vendorName: "Selva", contactNumber: "8754697585", materialSupplied: "Concrete", supplyType: "In", advance: "2000", totalAmount: "20000", invoiceStatus: "Overdue", gstNo: "33AAACH7409R1Z8" },
    { id: "2", vendorName: "John", contactNumber: "8754697585", materialSupplied: "Steel", supplyType: "Out", advance: "6000", totalAmount: "650000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z9" },
    { id: "3", vendorName: "Perter", contactNumber: "7854521652", materialSupplied: "Bricks", supplyType: "In", advance: "4500", totalAmount: "450000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z10" },
    { id: "4", vendorName: "Max", contactNumber: "7452145527", materialSupplied: "Cement", supplyType: "Out", advance: "1000", totalAmount: "20000", invoiceStatus: "Overdue", gstNo: "33AAACH7409R1Z11" },
    { id: "5", vendorName: "Vigan", contactNumber: "9874571415", materialSupplied: "Glass", supplyType: "In", advance: "7000", totalAmount: "90000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z12" },
    { id: "6", vendorName: "Suresh", contactNumber: "6547892578", materialSupplied: "Stone", supplyType: "In", advance: "5000", totalAmount: "55000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z13" },
    { id: "7", vendorName: "Ramesh", contactNumber: "8754698778", materialSupplied: "Tiles", supplyType: "In", advance: "7000", totalAmount: "75000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z14" },
    { id: "8", vendorName: "Karthik", contactNumber: "7548796575", materialSupplied: "Aggregates", supplyType: "Out", advance: "3000", totalAmount: "30000", invoiceStatus: "Overdue", gstNo: "33AAACH7409R1Z15" },
    { id: "9", vendorName: "Raja", contactNumber: "5748965587", materialSupplied: "Electrical Materials", supplyType: "In", advance: "4000", totalAmount: "45000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z16" },
    { id: "10", vendorName: "Mohan", contactNumber: "8574697842", materialSupplied: "Roofing Materials", supplyType: "Out", advance: "8000", totalAmount: "85000", invoiceStatus: "Paid", gstNo: "33AAACH7409R1Z17" }
  ];

  const stockInData = [
    { id: 1, materialtype: "MSAND", grade: "9", qty: "140", vendor: "MMR", totalamount: "10000", advance: "1500", supervisor: "Selva" },
    { id: 2, materialtype: "Aggregate", grade: "-", qty: "410", vendor: "RRK", totalamount: "15000", advance: "6000", supervisor: "Kumar" },
    { id: 3, materialtype: "Cement", grade: "-", qty: "520", vendor: "National", totalamount: "10000", advance: "3000", supervisor: "Sekar" },
    { id: 4, materialtype: "Dust", grade: "-", qty: "600", vendor: "MMR", totalamount: "35000", advance: "", supervisor: "Senthil" },
    { id: 5, materialtype: "Bitamin(Thar)", grade: "-", qty: "820", vendor: "JJ", totalamount: "20000", advance: "7000", supervisor: "Jana" },
    { id: 6, materialtype: "LDO Oil", grade: "-", qty: "582", vendor: "TRN", totalamount: "40000", advance: "", supervisor: "Kathir" },
    { id: 7, materialtype: "Diesel", grade: "10", qty: "985", vendor: "LLP", totalamount: "25000", advance: "-", supervisor: "Sathik" },
    { id: 8, materialtype: "Aggregate", grade: "-", qty: "456", vendor: "RRK", totalamount: "50000", advance: "-", supervisor: "Saran" },
    { id: 9, materialtype: "Cement", grade: "-", qty: "200", vendor: "JJN", totalamount: "40000", advance: "", supervisor: "Vignesh" },
    { id: 10, materialtype: "Dust", grade: "-", qty: "874", vendor: "Arjun", totalamount: "20000", advance: "8000", supervisor: "Sudha" }
  ];

  const stockOutData = [
    { id: 1, materialtype: "RMC", grade: "M10", grosswt: "-", tarewt: "-", netwt: "-", qty: "140", vehicleno: "TN13 2345", vehicletype: "Own", fromplant: "Plant 1", tosites: "Sites 1", totalamount: "10000", advance: "2000" },
    { id: 2, materialtype: "BT", grade: "BC", grosswt: "200", tarewt: "50", netwt: "50", qty: "410", vehicleno: "TN13 5875", vehicletype: "Rent", fromplant: "Plant 2", tosites: "KKN", totalamount: "15000", advance: "2500" },
    { id: 3, materialtype: "BT", grade: "BC", grosswt: "550", tarewt: "20", netwt: "30", qty: "520", vehicleno: "TN24 2574", vehicletype: "Own", fromplant: "Plant 3", tosites: "Sites 2", totalamount: "10000", advance: "2000" },
    { id: 4, materialtype: "RMC", grade: "M20", grosswt: "-", tarewt: "-", netwt: "-", qty: "600", vehicleno: "TN32 2875", vehicletype: "Rent", fromplant: "Plant 3", tosites: "Sites 3", totalamount: "35000", advance: "3000" },
    { id: 5, materialtype: "BM", grade: "BM", grosswt: "820", tarewt: "10", netwt: "10", qty: "820", vehicleno: "TN41 5345", vehicletype: "Rent", fromplant: "Plant 2", tosites: "MNK", totalamount: "20000", advance: "5000" },
    { id: 6, materialtype: "BM", grade: "BM", grosswt: "300", tarewt: "50", netwt: "50", qty: "582", vehicleno: "TN10 2587", vehicletype: "Own", fromplant: "Plant 1", tosites: "Sites 4", totalamount: "40000", advance: "6000" },
    { id: 7, materialtype: "BT", grade: "BM", grosswt: "200", tarewt: "20", netwt: "80", qty: "985", vehicleno: "TN11 5748", vehicletype: "Own", fromplant: "Plant 2", tosites: "Sites 1", totalamount: "25000", advance: "7000" },
    { id: 8, materialtype: "RMC", grade: "M20", grosswt: "-", tarewt: "-", netwt: "-", qty: "456", vehicleno: "TN25 8345", vehicletype: "Own", fromplant: "Plant 3", tosites: "MMK", totalamount: "50000", advance: "8000" },
    { id: 9, materialtype: "BM", grade: "BM", grosswt: "680", tarewt: "50", netwt: "30", qty: "200", vehicleno: "TN43 6345", vehicletype: "Own", fromplant: "Plant 3", tosites: "KKN", totalamount: "40000", advance: "9000" },
    { id: 10, materialtype: "BT", grade: "BC", grosswt: "400", tarewt: "25", netwt: "75", qty: "874", vehicleno: "TN43 534", vehicletype: "Rent", fromplant: "Plant 2", tosites: "MMK", totalamount: "20000", advance: "2000" }
  ];

  const transportData = [
    { id: "1", type: "JCB", vehicleprovider: "Own", startreading: "09:00 AM", endreading: "01:00 PM", totalhours: "04:00" },
    { id: "2", type: "Poklaine", vehicleprovider: "Rent", startreading: "10:00 AM", endreading: "02:00 PM", totalhours: "04:00" },
    { id: "3", type: "Tipper 1(Multiple Tipper)", vehicleprovider: "Rent", startreading: "11:30 AM", endreading: "03:00 PM", totalhours: "03:30" },
    { id: "4", type: "JCB", vehicleprovider: "Own", startreading: "12:00 PM", endreading: "04:00 PM", totalhours: "04:00" },
    { id: "5", type: "Poklaine", vehicleprovider: "Rent", startreading: "12:30 PM", endreading: "03:00 PM", totalhours: "02:30" },
    { id: "6", type: "Tipper 1(Multiple Tipper)", vehicleprovider: "Own", startreading: "01:00 PM", endreading: "04:30 PM", totalhours: "04:30" },
    { id: "7", type: "JCB", vehicleprovider: "Rent", startreading: "03:00 PM", endreading: "05:00 PM", totalhours: "02:00" },
    { id: "8", type: "Poklaine", vehicleprovider: "Own", startreading: "04:30 PM", endreading: "06:00 PM", totalhours: "01:30" },
    { id: "9", type: "Tipper 1(Multiple Tipper)", vehicleprovider: "Rent", startreading: "04:00 PM", endreading: "05:00 PM", totalhours: "01:00" },
    { id: "10", type: "JCB", vehicleprovider: "Own", startreading: "05:00 PM", endreading: "07:00 PM", totalhours: "02:00" }
  ];

  const employeeData = [
    {
      id: "SM001",
      name: "Selva",
      phoneNumber: "8754697585",
      email: "selva@gmail.com",
      role: "Supervisor",
      address: "Akshya Nagar ",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
    {
      id: "SM002",
      name: "Emma",
      phoneNumber: "8754697585",
      email: "emma@gmail.com",
      role: "Staff",
      address: "127 North Stt",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
    {
      id: "SM003",
      name: "Mark",
      phoneNumber: "8754697585",
      email: "mark@gmail.com",
      role: "Manager",
      address: "520 Ashe Ave",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "-",
      checkOut: "-",
      status: "Absent",
    },
    {
      id: "SM004",
      name: "John",
      phoneNumber: "8754697585",
      email: "john@gmail.com",
      role: "Staff",
      address: "505 Martin Luther",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "-",
      checkOut: "-",
      status: "Absent",
    },
    {
      id: "SM005",
      name: "Lily",
      phoneNumber: "8754697585",
      email: "lily@gmail.com",
      role: "SuperVisor",
      address: "2116-D New Bern",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "-",
      checkOut: "-",
      status: "Absent",
    },  
    {
      id: "SM006",
      name: "Daniel",
      phoneNumber: "8754697585",
      email: "daniel@gmail.com",
      role: "Staff",
      address: "400 Donald Ross Dr",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
    {
      id: "SM007",
      name: "Daniel",
      phoneNumber: "8754697585",
      email: "daniel@gmail.com",
      role: "Manager",
      address: "400 Donald Ross Dr",
      alternateNo: "8574697842",
      advance: "-",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
    {
      id: "SM008",
      name: "Jude",
      phoneNumber: "7548796575",
      email: "jude@gmail.com",
      role: "Staff",
      address: "3000 New Bern Ave",
      alternateNo: "7452145527",
      advance: "7000",
      checkIn: "-",
      checkOut: "-",
      status: "Absent",
    },
    {
      id: "SM009",
      name: "Robison",
      phoneNumber: "8754697585",
      email: "robison@gmail.com",
      role: "Manger",
      address: "Raleigh, NC",
      alternateNo: "5748965587",
      advance: "9000",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
    {
      id: "SM0010",
      name: "Peter",
      phoneNumber: "8754697585",
      email: "peter8745@gmail.com",
      role: "Supervisor",
      address: "1070 Partners Way",
      alternateNo: "7548796575",
      advance: "10000",
      checkIn: "09:00 AM",
      checkOut: "07:00 PM",
      status: "Present",
    },
  ];

  // Calculate report statistics
  const reportStats = useMemo(() => {
    const vendorStats = {
      totalVendors: vendorsData.length,
      totalAmount: vendorsData.reduce((sum, vendor) => sum + parseInt(vendor.totalAmount), 0),
      totalAdvance: vendorsData.reduce((sum, vendor) => sum + parseInt(vendor.advance), 0),
      paidInvoices: vendorsData.filter(vendor => vendor.invoiceStatus === 'Paid').length,
      overdueInvoices: vendorsData.filter(vendor => vendor.invoiceStatus === 'Overdue').length,
      inSuppliers: vendorsData.filter(vendor => vendor.supplyType === 'In').length,
      outSuppliers: vendorsData.filter(vendor => vendor.supplyType === 'Out').length
    };

    const stockInStats = {
      totalItems: stockInData.length,
      totalQuantity: stockInData.reduce((sum, item) => sum + parseInt(item.qty), 0),
      totalValue: stockInData.reduce((sum, item) => sum + parseInt(item.totalamount), 0),
      totalAdvance: stockInData.reduce((sum, item) => sum + (parseInt(item.advance) || 0), 0),
      materials: [...new Set(stockInData.map(item => item.materialtype))].length
    };

    const stockOutStats = {
      totalItems: stockOutData.length,
      totalQuantity: stockOutData.reduce((sum, item) => sum + parseInt(item.qty), 0),
      totalValue: stockOutData.reduce((sum, item) => sum + parseInt(item.totalamount), 0),
      totalAdvance: stockOutData.reduce((sum, item) => sum + parseInt(item.advance), 0),
      ownVehicles: stockOutData.filter(item => item.vehicletype === 'Own').length,
      rentVehicles: stockOutData.filter(item => item.vehicletype === 'Rent').length
    };

    const transportStats = {
      totalVehicles: transportData.length,
      totalHours: transportData.reduce((sum, item) => {
        const [hours, minutes] = item.totalhours.split(':').map(Number);
        return sum + hours + (minutes / 60);
      }, 0),
      ownVehicles: transportData.filter(item => item.vehicleprovider === 'Own').length,
      rentVehicles: transportData.filter(item => item.vehicleprovider === 'Rent').length,
      vehicleTypes: [...new Set(transportData.map(item => item.type))].length
    };

    const employeeStats = {
      totalEmployees: employeeData.length,
      presentEmployees: employeeData.filter(emp => emp.status === 'Present').length,
      absentEmployees: employeeData.filter(emp => emp.status === 'Absent').length,
      supervisors: employeeData.filter(emp => emp.role.toLowerCase().includes('supervisor')).length,
      managers: employeeData.filter(emp => emp.role.toLowerCase().includes('manager')).length,
      staff: employeeData.filter(emp => emp.role.toLowerCase().includes('staff')).length,
      totalAdvance: employeeData.reduce((sum, emp) => sum + (parseInt(emp.advance) || 0), 0),
      attendanceRate: Math.round((employeeData.filter(emp => emp.status === 'Present').length / employeeData.length) * 100)
    };

    return { vendorStats, stockInStats, stockOutStats, transportStats, employeeStats };
  }, []);

  const reportTypes = [
    { 
      id: 'vendor', 
      name: 'Vendor Report', 
      description: 'Vendor performance and financial analysis', 
      icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z',
      data: vendorsData,
      stats: reportStats.vendorStats
    },
    { 
      id: 'stockin', 
      name: 'Stock In Report', 
      description: 'Inventory received and material analysis', 
      icon: 'M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4',
      data: stockInData,
      stats: reportStats.stockInStats
    },
    { 
      id: 'stockout', 
      name: 'Stock Out Report', 
      description: 'Inventory dispatched and delivery analysis', 
      icon: 'M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2',
      data: stockOutData,
      stats: reportStats.stockOutStats
    },
    { 
      id: 'transport', 
      name: 'Transport Report', 
      description: 'Vehicle usage and logistics analysis', 
      icon: 'M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4',
      data: transportData,
      stats: reportStats.transportStats
    },
    { 
      id: 'employee', 
      name: 'Employee Report', 
      description: 'Employee attendance and workforce analysis', 
      icon: 'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
      data: employeeData,
      stats: reportStats.employeeStats
    },
  ];

  // Pagination logic for report data
  const totalPages = selectedReport ? Math.ceil(selectedReport.data.length / itemsPerPage) : 0;
  const paginatedData = useMemo(() => {
    if (!selectedReport) return [];
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return selectedReport.data.slice(startIndex, endIndex);
  }, [selectedReport, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };

  const generateReport = (report) => {
    setSelectedReport(report);
    setCurrentPage(1);
  };

  const closeReport = () => {
    setSelectedReport(null);
    setCurrentPage(1);
  };

  // Download functions
  const downloadPDF = async () => {
    if (!selectedReport) return;

    // Dynamically import autoTable
    const autoTable = (await import('jspdf-autotable')).default;
    
    const doc = new jsPDF();
    const currentDate = new Date().toLocaleDateString();
    
    // Add title
    doc.setFontSize(20);
    doc.text(selectedReport.name, 14, 22);
    
    // Add date
    doc.setFontSize(10);
    doc.text(`Generated on: ${currentDate}`, 14, 30);
    
    // Add statistics
    doc.setFontSize(12);
    doc.text('Summary Statistics:', 14, 40);
    
    let yPosition = 50;
    Object.entries(selectedReport.stats).forEach(([key, value]) => {
      const label = key.replace(/([A-Z])/g, ' $1').trim();
      const displayValue = typeof value === 'number' && value > 1000 && key !== 'attendanceRate' 
        ? `₹${value.toLocaleString()}` 
        : key === 'attendanceRate' 
        ? `${value}%` 
        : value;
      
      doc.setFontSize(10);
      doc.text(`${label}: ${displayValue}`, 14, yPosition);
      yPosition += 6;
    });

    // Add table
    const tableData = selectedReport.data.map(item => {
      switch (selectedReport.id) {
        case 'vendor':
          return [
            item.id,
            item.vendorName,
            item.contactNumber,
            item.materialSupplied,
            item.supplyType,
            `₹${item.advance}`,
            `₹${item.totalAmount}`,
            item.invoiceStatus,
            item.gstNo
          ];
        case 'stockin':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vendor,
            `₹${item.totalamount}`,
            `₹${item.advance || '-'}`,
            item.supervisor
          ];
        case 'stockout':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vehicleno,
            item.vehicletype,
            item.fromplant,
            item.tosites,
            `₹${item.totalamount}`,
            `₹${item.advance}`
          ];
        case 'transport':
          return [
            item.id,
            item.type,
            item.vehicleprovider,
            item.startreading,
            item.endreading,
            item.totalhours
          ];
        case 'employee':
          return [
            item.id,
            item.name,
            item.phoneNumber,
            item.email,
            item.role,
            item.address,
            item.checkIn,
            item.checkOut,
            item.advance === '-' ? '-' : `₹${item.advance}`,
            item.status
          ];
        default:
          return [];
      }
    });

    const headers = getTableHeaders();
    
    // Use autoTable for better formatting
    autoTable(doc, {
      head: [headers],
      body: tableData,
      startY: yPosition + 10,
      styles: { fontSize: 8 },
      headStyles: { fillColor: [0, 150, 136] },
      margin: { top: 20 }
    });

    doc.save(`${selectedReport.name.replace(' ', '_')}_${currentDate.replace(/\//g, '-')}.pdf`);
  };

  const downloadExcel = () => {
    if (!selectedReport) return;

    const currentDate = new Date().toLocaleDateString();
    
    // Prepare data for Excel
    const headers = getTableHeaders();
    const tableData = selectedReport.data.map(item => {
      switch (selectedReport.id) {
        case 'vendor':
          return [
            item.id,
            item.vendorName,
            item.contactNumber,
            item.materialSupplied,
            item.supplyType,
            item.advance,
            item.totalAmount,
            item.invoiceStatus,
            item.gstNo
          ];
        case 'stockin':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vendor,
            item.totalamount,
            item.advance || '-',
            item.supervisor
          ];
        case 'stockout':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vehicleno,
            item.vehicletype,
            item.fromplant,
            item.tosites,
            item.totalamount,
            item.advance
          ];
        case 'transport':
          return [
            item.id,
            item.type,
            item.vehicleprovider,
            item.startreading,
            item.endreading,
            item.totalhours
          ];
        case 'employee':
          return [
            item.id,
            item.name,
            item.phoneNumber,
            item.email,
            item.role,
            item.address,
            item.checkIn,
            item.checkOut,
            item.advance,
            item.status
          ];
        default:
          return [];
      }
    });

    // Create workbook
    const wb = XLSX.utils.book_new();
    
    // Add statistics sheet
    const statsData = [
      ['Summary Statistics'],
      ['Generated on', currentDate],
      [''],
      ...Object.entries(selectedReport.stats).map(([key, value]) => [
        key.replace(/([A-Z])/g, ' $1').trim(),
        typeof value === 'number' && value > 1000 && key !== 'attendanceRate' 
          ? value.toLocaleString() 
          : key === 'attendanceRate' 
          ? `${value}%` 
          : value
      ])
    ];
    
    const statsWS = XLSX.utils.aoa_to_sheet(statsData);
    XLSX.utils.book_append_sheet(wb, statsWS, 'Statistics');
    
    // Add data sheet
    const dataWS = XLSX.utils.aoa_to_sheet([headers, ...tableData]);
    XLSX.utils.book_append_sheet(wb, dataWS, 'Data');
    
    // Save file
    const fileName = `${selectedReport.name.replace(' ', '_')}_${currentDate.replace(/\//g, '-')}.xlsx`;
    XLSX.writeFile(wb, fileName);
  };

  const getTableHeaders = () => {
    if (!selectedReport) return [];
    
    switch (selectedReport.id) {
      case 'vendor':
        return ['ID', 'Vendor Name', 'Contact', 'Material', 'Supply Type', 'Advance', 'Total Amount', 'Status', 'GST No'];
      case 'stockin':
        return ['ID', 'Material Type', 'Grade', 'Quantity', 'Vendor', 'Total Amount', 'Advance', 'Supervisor'];
      case 'stockout':
        return ['ID', 'Material Type', 'Grade', 'Quantity', 'Vehicle No', 'Vehicle Type', 'From Plant', 'To Sites', 'Total Amount', 'Advance'];
      case 'transport':
        return ['ID', 'Type', 'Provider', 'Start Time', 'End Time', 'Total Hours'];
      case 'employee':
        return ['ID', 'Name', 'Phone', 'Email', 'Role', 'Address', 'In Time', 'Out Time', 'Advance', 'Status'];
      default:
        return [];
    }
  };

  const renderReportTable = () => {
    if (!selectedReport) return null;

    const getTableData = (item) => {
      switch (selectedReport.id) {
        case 'vendor':
          return [
            item.id,
            item.vendorName,
            item.contactNumber,
            item.materialSupplied,
            item.supplyType,
            `₹${item.advance}`,
            `₹${item.totalAmount}`,
            item.invoiceStatus,
            item.gstNo
          ];
        case 'stockin':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vendor,
            `₹${item.totalamount}`,
            `₹${item.advance || '-'}`,
            item.supervisor
          ];
        case 'stockout':
          return [
            item.id,
            item.materialtype,
            item.grade,
            item.qty,
            item.vehicleno,
            item.vehicletype,
            item.fromplant,
            item.tosites,
            `₹${item.totalamount}`,
            `₹${item.advance}`
          ];
        case 'transport':
          return [
            item.id,
            item.type,
            item.vehicleprovider,
            item.startreading,
            item.endreading,
            item.totalhours
          ];
        case 'employee':
          return [
            item.id,
            item.name,
            item.phoneNumber,
            item.email,
            item.role,
            item.address,
            item.checkIn,
            item.checkOut,
            item.advance === '-' ? '-' : `₹${item.advance}`,
            item.status
          ];
        default:
          return [];
      }
    };

    return (
      <div className="space-y-6">
        <div className="flex justify-between items-center">
          <div>
            <h2 className="text-2xl font-bold text-gray-900 font-poppins">{selectedReport.name}</h2>
            <p className="text-sm text-gray-500">Generated on {new Date().toLocaleDateString()}</p>
          </div>
          <div className="flex space-x-3">
            <button
              onClick={downloadPDF}
              className="flex items-center px-4 py-2 text-sm font-medium text-white bg-red-600 border border-transparent rounded-md hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download PDF
            </button>
            <button
              onClick={downloadExcel}
              className="flex items-center px-4 py-2 text-sm font-medium text-white bg-green-600 border border-transparent rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Download Excel
            </button>
            <button
              onClick={closeReport}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
            >
              Back to Reports
            </button>
          </div>
        </div>

        {/* Statistics Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {Object.entries(selectedReport.stats).map(([key, value]) => (
            <div key={key} className="bg-white p-4 rounded-lg shadow border">
              <div className="text-sm font-medium text-gray-500 capitalize">
                {key.replace(/([A-Z])/g, ' $1').trim()}
              </div>
              <div className="text-2xl font-bold text-gray-900">
                {typeof value === 'number' && value > 1000 && key !== 'attendanceRate' ? `₹${value.toLocaleString()}` : 
                 key === 'attendanceRate' ? `${value}%` : value}
              </div>
            </div>
          ))}
        </div>

        {/* Data Table */}
        <div className="bg-white shadow rounded-lg">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  {getTableHeaders().map((header, index) => (
                    <th key={index} className="px-6 py-3 text-left text-xs font-medium text-gray-500 tracking-wider">
                      {header}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {paginatedData.map((item, index) => (
                  <tr key={item.id || index} className="hover:bg-gray-50">
                    {getTableData(item).map((cell, cellIndex) => (
                      <td key={cellIndex} className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {/* Pagination */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={handlePageChange}
            itemsPerPage={itemsPerPage}
            totalItems={selectedReport.data.length}
            onItemsPerPageChange={handleItemsPerPageChange}
          />
        </div>
      </div>
    );
  };

  if (selectedReport) {
    return renderReportTable();
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900 font-poppins">Reports</h1>
        <p className="mt-1 text-sm text-gray-500">Generate and view various business reports</p>
      </div>

      <Grid cols={2} gap={6} className="lg:grid-cols-3">
        {reportTypes.map((report, index) => (
          <div key={index} className="bg-white shadow rounded-lg p-6 hover:shadow-md transition-shadow">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <div className="w-12 h-12 bg-primary rounded-lg flex items-center justify-center">
                  <svg className="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={report.icon} />
                  </svg>
                </div>
              </div>
              <div className="ml-4">
                <h3 className="text-lg font-medium text-gray-900 font-poppins">{report.name}</h3>
                <p className="text-sm text-gray-500">{report.description}</p>
              </div>
            </div>
            <div className="mt-4">
              <button 
                onClick={() => generateReport(report)}
                className="btn-primary w-full"
              >
                Generate Report
              </button>
            </div>
          </div>
        ))}
      </Grid>
    </div>
  );
};

export default Reports;
